import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, Toaster } from '@share/utils';
import { axiosInstanceB2B } from '@share/utils';
import { IAccountPreference } from '@share/common-types';

export interface IUserSettingState {
  preferences: IAccountPreference[];
  isSuccess: boolean,
  loading: boolean;
}

const initialState: IUserSettingState = {
  preferences: [],
  isSuccess: false,
  loading: false
};

const userSettingSlice = createSlice({
  name: 'userSetting',
  initialState,
  reducers: {
    setLoading: (state: IUserSettingState, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setSuccess: (state: IUserSettingState, { payload }: PayloadAction<boolean>) => {
      state.isSuccess = payload;
    },
    setPreferences: (state: IUserSettingState, { payload }: PayloadAction<IAccountPreference[]>) => {
      state.preferences = payload;
    }
  },
});

export const userSettingActions = userSettingSlice.actions;
export const userSettingReducer = userSettingSlice.reducer;

export const handleUserPreferences = (userId: string | undefined, preferences: IAccountPreference[]): AppThunk => {
  return async (dispatch) => {
    dispatch(userSettingActions.setLoading(true));

    try {
      if (userId == undefined) {
        Toaster.error('A problem occurred while retrieving the user. Please try again.');
        return;
      }

      const response = await axiosInstanceB2B.post(`/identity/users/preferences`, { userId, preferences });
      if (!response.data.success) {
        Toaster.error('An error occurred. Please try again.');
      }
      dispatch(userSettingActions.setSuccess(response.data.success));
      dispatch(userSettingActions.setLoading(false));
    } catch (error: any) {
      Toaster.error('An error occurred. Please try again.');
      dispatch(userSettingActions.setSuccess(false));
      dispatch(userSettingActions.setLoading(false));
    }
  };
};